
import 'alpinejs';
import 'lozad';

try {
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) { }

/**
 * Sets the navbar class.
 *
 * Used for minifying the top navbar on desktop-sm+ after user scrolls the page
 */
function setNavbarClass() {
    // This value is your scroll distance from the top
    var distanceFromTop = document.documentElement.scrollTop || document.body.scrollTop;
    var nav = document.getElementById('navbar-container');
    var formShowDistanceFromTop = 300;

    if (window.location.pathname != '/') {
        // If on sub page show form when scrolling starts
        formShowDistanceFromTop = 1;
    }

    if (!nav) {
        return;
    }

    // The user has scrolled to the tippy top of the page. Set appropriate style.
    if (distanceFromTop <= formShowDistanceFromTop) {
        nav.className = '';
    }

    // The user has scrolled down the page.
    if (distanceFromTop > formShowDistanceFromTop) {
        nav.className = 'minify-nav';
    }
};

window.addEventListener('scroll', function (evt) {
    setNavbarClass();

    // Slide in particular elements on scroll
    let slides = document.getElementsByClassName('slide-in-scroll unslid');

    Array.prototype.forEach.call(slides, function (slide, index) {
        if (isInViewport(slide)) {
            slide.classList.replace('unslid', 'slide-in-active');
        }
    });
});

window.addEventListener('load', function () {
    setNavbarClass();

    // Slide in particular elements on load
    let slidesOnLoad = document.getElementsByClassName('slide-in slide-in-load');

    Array.prototype.forEach.call(slidesOnLoad, function (slideOnLoad, index) {
        slideOnLoad.classList.add('slide-in-active');
    });
});
